import ActionButtons from './ActionButtons';
import FieldsSection from './FieldsSection';

export {
  ActionButtons,
  FieldsSection,
};



// WEBPACK FOOTER //
// ./src/components/page/PrimaryDetails/components/index.js